module.exports = __webpack_public_path__ + "img/ring_r_o_null_0@3x.3f91b836.png";